import baseAPI from "@/http";

const router = "api/usuario";

export const usuarioAPI = {
  create: (usuario) => baseAPI.post(`${router}/register`, usuario),
  update: (usuario) => baseAPI.put(`${router}/atualizar-usuario`, usuario),
  trocarSenha: (usuario) => baseAPI.put(`${router}/atualizar-senha`, usuario),

  get: () => baseAPI.get(`${router}/obter-todos-usuarios`),
  getId: (id) => baseAPI.get(`${router}/obter-usuario-por-id?id=${id}`),
};
